<p-select
  id="languageSelector"
  [options]="(activeLanguages$ | async) ?? []"
  [(ngModel)]="selectedLanguage"
  (onChange)="onChangeLanguage()"
  styleClass="ml-2">
  <ng-template pTemplate="selectedItem">
    @if (selectedLanguage) {
      <div class="flex align-items-center gap-2">
        <span>{{ selectedLanguage.code }}</span>
      </div>
    }
  </ng-template>
  <ng-template let-activeLanguage pTemplate="item">
    <div class="flex align-items-center gap-2">
      <span>{{ activeLanguage.code }}</span>
    </div>
  </ng-template>
</p-select>
